import { reads } from 'macro-decorators';
import EventLogger from 'frontend/entities/chime/event-logger';
import Service, { service } from '@ember/service';

const EVENTS = {
  meetingStartSucceeded: 'meetingStartSucceeded',
  meetingEnded: 'meetingEnded',
};

export default class ChimeEventManagerService extends Service {
  @service('chime.sdk') sdkService;
  @reads('sdkService.sdk') chimeSdk;

  start(eventController) {
    let logger = new EventLogger(this.chimeSdk);

    eventController.addObserver({
      eventDidReceive: (name, attributes) => {
        switch (name) {
          case EVENTS.meetingStartSucceeded:
            logger.log(name, attributes);
            break;
          case EVENTS.meetingEnded:
            logger.log(name, attributes);
            logger.destroy();
        }
      },
    });
  }
}
